import { Button, Center, HStack } from '@chakra-ui/react';

interface OrderDetailActionsDesktopProps {
  onCreateShoppingList: () => Promise<void> | void;
  onBuyAgain: () => Promise<void> | void;
  isLoading: boolean;
}

export const OrderDetailActionsDesktop = ({
  onCreateShoppingList,
  onBuyAgain,
  isLoading,
}: OrderDetailActionsDesktopProps) => (
  <Center>
    <HStack>
      <Button
        width="190px"
        variant="outline"
        onClick={() => {
          void onCreateShoppingList();
        }}
      >
        Daftar Belanja Baru
      </Button>
      <Button
        variant="solid"
        width="190px"
        onClick={() => {
          void onBuyAgain();
        }}
        isLoading={isLoading}
      >
        <span>Beli Lagi</span>
      </Button>
    </HStack>
  </Center>
);
